import * as React from "react";
import { Filter } from "@devexpress/dx-react-grid";

export function useFiltering() {
  const [filters, setFilters] = React.useState<Filter[]>([]);

  return { filters, setFilters };
}
